<template>
  <i :class="`icon-${name}`" :style="{ fontSize: `${size}px`, color: `${color} !important`}" :title="title"></i>
</template>
<script>
export default {
  name: 'AgroIcons',

  props: {
    name: { type: String, default: '' },
    size: { type: Number | String, default: '1.5em' },
    color: { type: String, default: 'inherit' },
    title: { type: String, default: null },
  },
};
</script>
